import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { RefreshCw } from "lucide-react";

/**
 * Modal dialog for scorer transfer notifications.
 * This is a centered, non-dismissible popup that requires user action.
 */
const ScorerTransferNotification = ({ notification, onDismiss }) => {
  const navigate = useNavigate();
  
  if (!notification) return null;
  
  const handleContinueScoring = () => {
    onDismiss();
    navigate(`/scoring/${notification.match_id}`);
  };
  
  const handleViewMatch = () => {
    onDismiss();
    navigate(`/match/${notification.match_id}`);
  };
  
  return (
    <Dialog open={!!notification} onOpenChange={() => {}}>
      <DialogContent 
        className="bg-slate-900 border-[#CCFF00]/30 max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        hideClose
      >
        <DialogHeader className="text-center">
          <div className="w-20 h-20 rounded-full bg-[#CCFF00]/20 flex items-center justify-center mx-auto mb-4">
            <RefreshCw className="w-10 h-10 text-[#CCFF00] animate-pulse" />
          </div>
          <DialogTitle className="text-2xl font-bold text-white">
            Scoring Transferred to You!
          </DialogTitle>
          <DialogDescription className="text-slate-400 text-base mt-2">
            {notification.from_name || "Another user"} has transferred the scoring rights to you.
          </DialogDescription>
        </DialogHeader>
        
        <div className="mt-4 space-y-4">
          <div className="bg-slate-800/50 rounded-lg p-4 text-center">
            <p className="text-sm text-slate-500 mb-1">Match</p>
            <p className="text-lg font-semibold text-white">
              {notification.match_info?.team_a_name || 'Team A'} vs {notification.match_info?.team_b_name || 'Team B'}
            </p>
          </div>
          
          <div className="flex flex-col gap-3">
            <Button
              className="w-full bg-[#CCFF00] text-[#020617] hover:bg-[#CCFF00]/80 font-semibold py-6 text-lg"
              onClick={handleContinueScoring}
              data-testid="continue-scoring-modal-btn"
            >
              Continue Scoring
            </Button>
            <Button
              variant="outline"
              className="w-full border-slate-700 text-slate-300 hover:bg-slate-800 py-5"
              onClick={handleViewMatch}
              data-testid="view-match-modal-btn"
            >
              View Match Details
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ScorerTransferNotification;
